// The speaker details request email (Invitations › Speaker details, wireframe
// "Suite Event Speaker Invite"): staff edit its subject and message per event,
// with placeholders filled per person when it is sent. {link} is the
// speaker's personal link to their form, so the message must keep it.
// The same fill runs on the server (the email) and in the browser (the preview).

export const SPEAKER_EMAIL_PLACEHOLDERS = ["{salutation}", "{first name}", "{event title}", "{event date}", "{deadline}", "{link}"] as const;
export type SpeakerEmailPlaceholder = (typeof SPEAKER_EMAIL_PLACEHOLDERS)[number];

/** The values for one person. */
/** salutation: "Ms JovanoviÄ‡", or the full name when the gender is not known (round 5, EM8: one greeting rule). */
export type SpeakerEmailValues = { salutation: string; firstName: string; eventTitle: string; eventDate: string; deadline: string; link: string };

/** M38 (Marius's wireframe): "Your session in Skopje: we need a few details". */
export const SPEAKER_EMAIL_DEFAULT_SUBJECT = "Your session at {event title}: we need a few details";
export const SPEAKER_EMAIL_DEFAULT_BODY = [
  "Dear {salutation},",
  "Thank you for speaking at {event title} on {event date}. To prepare the programme, the name badges and your travel, could you send us your title, a short biography and a photo by {deadline}?",
  "{link}",
  "It takes about five minutes. You can come back to the same link to change your answers until the event is closed.",
  "With kind regards,",
].join("\n\n");

/** The reminder goes this many days after the request, to people who have not sent their details (wireframe: "after 5 days"). */
export const SPEAKER_REMINDER_DEFAULT_DAYS = 5;
/** Without an answer-by date, {deadline} is this many days before the event starts. */
export const SPEAKER_DEADLINE_DEFAULT_DAYS_BEFORE = 7;

export const SPEAKER_EMAIL_LINK_MISSING = "Keep {link} in the message. It is the speaker's personal link to the form.";

const PLACEHOLDER = /\{\s*([a-z ]+?)\s*\}/gi;

/** Fills the placeholders ({First name} and { first name } count too). Unknown ones stay as they are. */
export function fillSpeakerEmail(text: string, v: SpeakerEmailValues): string {
  const map: Record<string, string> = { salutation: v.salutation, "first name": v.firstName, "event title": v.eventTitle, "event date": v.eventDate, deadline: v.deadline, link: v.link };
  return text.replace(PLACEHOLDER, (whole, name: string) => map[name.toLowerCase().replace(/\s+/g, " ")] ?? whole);
}

/** True when the text has {link}. */
export const hasLinkPlaceholder = (text: string): boolean => [...text.matchAll(PLACEHOLDER)].some((m) => m[1].toLowerCase() === "link");

/** Placeholders in the text that are not known, e.g. "{name}". */
export function unknownPlaceholders(text: string): string[] {
  const known = new Set(SPEAKER_EMAIL_PLACEHOLDERS.map((p) => p.slice(1, -1)));
  return [...new Set([...text.matchAll(PLACEHOLDER)].filter((m) => !known.has(m[1].toLowerCase().replace(/\s+/g, " "))).map((m) => m[0]))];
}
